import { render, staticRenderFns } from "./specialShips.vue?vue&type=template&id=0b79ccd0&scoped=true&"
import script from "./specialShips.vue?vue&type=script&lang=js&"
export * from "./specialShips.vue?vue&type=script&lang=js&"
import style0 from "./specialShips.vue?vue&type=style&index=0&id=0b79ccd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b79ccd0",
  null
  
)

export default component.exports